export const SURVEY_QUESTIONNAIRE_COLLECTION = "surveyQuestionnaire";
